 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a4a2fc085f78500cde3eaed9047e30244ca6fcfd","1":"44461f0d8d797552915291517099005aabe2eb53","2":"d3ca0da56ac373ae258989c1bff587ff51bab87c","3":"de828b85fad1729da686924217d80761a33aabf0","6":"component---src-pages-404-js","7":"component---src-pages-api-canvas-frame-mdx","8":"component---src-pages-api-circle-mdx","9":"component---src-pages-api-common-controls-props-mdx","10":"component---src-pages-api-counter-mdx","11":"component---src-pages-api-default-timer-mdx","12":"component---src-pages-api-draw-mdx","13":"component---src-pages-api-grid-mdx","14":"component---src-pages-api-indicator-mdx","15":"component---src-pages-api-mdx","16":"component---src-pages-api-model-props-mdx","17":"component---src-pages-api-model-state-mdx","18":"component---src-pages-api-options-mdx","19":"component---src-pages-api-radio-mdx","20":"component---src-pages-api-range-mdx","21":"component---src-pages-api-round-rectangle-mdx","22":"component---src-pages-api-select-mdx","23":"component---src-pages-api-series-mdx","24":"component---src-pages-api-style-mdx","25":"component---src-pages-api-time-series-mdx","26":"component---src-pages-api-timer-mdx","27":"component---src-pages-api-update-data-mdx","28":"component---src-pages-api-with-controls-mdx","29":"component---src-pages-api-with-frame-mdx","30":"component---src-pages-concepts-mdx","31":"component---src-pages-controls-arranging-controls-mdx","32":"component---src-pages-controls-checkbox-mdx","33":"component---src-pages-controls-custom-controls-mdx","34":"component---src-pages-controls-default-timer-mdx","35":"component---src-pages-controls-input-mdx","36":"component---src-pages-controls-mdx","37":"component---src-pages-controls-pre-defined-types-mdx","38":"component---src-pages-controls-radio-mdx","39":"component---src-pages-controls-range-mdx","40":"component---src-pages-controls-select-mdx","41":"component---src-pages-controls-timer-mdx","42":"component---src-pages-controls-toggle-mdx","43":"component---src-pages-examples-activators-mdx","44":"component---src-pages-examples-automata-mdx","45":"component---src-pages-examples-boids-mdx","46":"component---src-pages-examples-chaos-game-mdx","47":"component---src-pages-examples-dice-mdx","48":"component---src-pages-examples-epidemic-mdx","49":"component---src-pages-examples-fibonacci-mdx","50":"component---src-pages-examples-game-of-life-mdx","51":"component---src-pages-examples-index-js","52":"component---src-pages-examples-mazes-mdx","53":"component---src-pages-examples-model-mdx","54":"component---src-pages-examples-percolation-mdx","55":"component---src-pages-examples-segregation-mdx","56":"component---src-pages-examples-snake-mdx","57":"component---src-pages-frame-helpers-canvas-frame-mdx","58":"component---src-pages-frame-helpers-grid-mdx","59":"component---src-pages-frame-helpers-mdx","60":"component---src-pages-frame-helpers-time-series-mdx","61":"component---src-pages-frames-mdx","62":"component---src-pages-fullsize-js","63":"component---src-pages-index-mdx","64":"component---src-pages-init-data-mdx","65":"component---src-pages-installation-mdx","66":"component---src-pages-motivation-mdx","67":"component---src-pages-on-two-rows-mdx","68":"component---src-pages-test-mdx","69":"component---src-pages-time-mdx","70":"component---src-pages-tutorial-mdx"}[chunkId]||chunkId) + "-" + {"0":"76ffcb6c838d162aabd9","1":"9e51108a8961e65bae59","2":"fd5f7881b1533fbe0402","3":"500958a0ed6b5c630b5a","6":"d6f092260f9df08398ff","7":"8a1766bed7e3536eebe3","8":"5a900debfbde6ef6f0a9","9":"86561ae63bb4d0fd38ce","10":"b7fed10b44be1b77da49","11":"fb3c43cee5f4deca1dfb","12":"4f9fde1754b06beef12b","13":"7c6e0b713723b86f8652","14":"e3444132d9a7177b4815","15":"c3feef0e073a99d4212d","16":"9cc79139f7c5f7bfa056","17":"a807750cdea1823954da","18":"d576980407a4784c92f4","19":"6c808b29baa822c14774","20":"28c3ca8c03a09f4db2b6","21":"14597cb23e0e857efb09","22":"f97351cf715e7d40ba1a","23":"690829d4015830f67c9b","24":"bb706bebf0865abd2ab8","25":"435e40d6283a06fc4abf","26":"6b841758f4d8353ba9de","27":"cf47dfa902a8c2a1d2ca","28":"d05258ae4aacab8f1381","29":"a19bb6d6f3ef96ad3b25","30":"8b4f4a70361790e79390","31":"a9976a4a07321a206009","32":"82b4b7e4dd8457e2975d","33":"a287ec8aed576481875e","34":"b77b0420d9c91ff1350f","35":"2737e5b68bb4e656f56c","36":"b5e6a1558a8aa718012f","37":"9bc0cb42b824177bc9fe","38":"2698f5297553c52c50b9","39":"7dc94801e8374081c33d","40":"1e3d50665a25747e7c9e","41":"c6cc47d400a366a6f2dd","42":"34c8f7b7e8a7446319af","43":"0926ab6da2206e8fe823","44":"9c342474b0011b105414","45":"d792b44ba26605048810","46":"61f492393c5891df01d6","47":"fb762f54f164e086b759","48":"164fe2494a8636145837","49":"a21db02d944f8beecb61","50":"87b4ab756bc4556f7a28","51":"ff04beee58dee6a3137e","52":"1dece8a038b86ad26075","53":"c264e5eb95711bd0a05e","54":"b7193b614ac579a48b67","55":"07abdf7e87571e2afd83","56":"cb414584b42d4020ce4e","57":"3fb9d5a03cb8cde3d914","58":"f977cd834c5a41ba9ef7","59":"e11c436037b3455b517e","60":"12c478e5c369b866cf22","61":"e51183fe8b043388a17f","62":"dbd256548e87b5b648bd","63":"721231fc0065643ff633","64":"2350e7682bd757969569","65":"de8fd777d3333a4930e8","66":"686fa3ece67c05b73bce","67":"9362f3b25c9204e4c7e5","68":"2cb39d87fd3a60aa6b0f","69":"48da361974c2b4d6ab45","70":"d4ee0a7d7a4d5b0dfc30"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/react-sim/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
